import voidedSales from '@js/store/modules/voided-sales';

export default {
    created() {
        if (!this.$store.hasModule('voidedSales')) {
            this.$store.registerModule('voidedSales', voidedSales);
        }
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/voided-type-filter/voided-type-mixin.js